<script>
    import IacCard from "./IacCard.svelte";

    export let iacCards;
</script>

<ul cy_data="iac_card_list">
    {#if iacCards.lenght === 0}
        <p>Não há vagas disponívels para essa nota! 😔</p>
    {:else}
        {#each iacCards as iacCard}
            <IacCard {iacCard} />
        {/each}
    {/if}
</ul>
